var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getState)?_c('div',{staticClass:"loader"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader__window"},[_c('img',{attrs:{"src":"https://media.giphy.com/media/xTiTnD4d66fshHzTxK/giphy.gif"}})])
}]

export { render, staticRenderFns }